<template>
    <div class="card light-back max-content-width w-100">
        <div class="card-body">
            <div class="small-box">
                <a @click="changeStep" :class="{ 'disabled': store.isLoading }" class="btn btn-primary btn-block mb-4">
                    <MoveForwardButton buttonText="ALUSTA KUULUTUSE LISAMIST"/>
                </a>
                <span v-if="!store.introText">{{ $t("Laeb lehte") }}</span>
                <span v-else v-html="store.introText"></span>
            </div>
        </div>
    </div>
</template>

<script setup>
import MoveForwardButton from './MoveForwardButton.vue';
import { useMainStore } from '../includes/store';

const store = useMainStore();

const changeStep = () => {
    store.changeStep('adType');
}
</script>
